<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>


<script type="text/javascript">
	import Shutter from "@/mixins/Shutter.js"
	import ShutterInvoice from "@/mixins/shutters-manager/Invoice.js"

	/**
	 * Écran d'une vue de suivi des factures fournisseurs. Il n'existe que pour ouvrir la liste dans un
	 * volet, comme le font les écrans voisins ; le contenu vit dans BucketList.
	 */
	export default {
		name: 'InvoiceSupplierBucket',
		mixins: [Shutter, ShutterInvoice],
		props: {
			bucket: { type: String, required: true },
			// Sur la fiche d'un fournisseur, la vue ne montre que ses factures.
			tiers_id: { type: [String, Number], default: null }
		},

		watch: {
			// Passer d'un onglet à l'autre ne détruit pas l'écran : le volet est rouvert sur la
			// nouvelle vue, sans quoi la liste resterait celle de l'onglet précédent.
			bucket: 'init_component'
		},

		mounted() {
			this.init_component()
		},

		methods: {
			init_component() {
				// La période est portée par l'adresse : elle n'est posée que par les liens qui visent
				// une facture précise, et seules les vues qui filtrent sur une période s'en servent.
				const { start, end } = this.$route.query

				this.setUpInvoiceSupplierBucket(this.bucket, this.tiers_id, start, end)
			}
		}
	}
</script>
